import { ActionType } from 'typesafe-actions';
import { ActionTypes } from './actionTypes';
import * as actions from './actions';
import { State } from './types';

export const initialState: State = {
  // Informes horas
  informesHoras: [],
  informesHorasCount: 0,

  // Informes horas instructor
  informesHorasInstructor: [],
  informesHorasInstructorCount: 0,

  // Informes infraestructura
  informesInfraestructura: [],
  informesInfraestructuraCount: 0,

  // Filtros
  sociedades: [],
  provincias: [],
  estados: [],
  cursosFilter: [],
  alumnos: [],

  // Cache
  allCursosFilter: [],
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    // informes Horas
    case ActionTypes.SET_INFORMES_HORAS:
      return {
        ...state,
        informesHoras: action.payload,
      };
    case ActionTypes.SET_INFORMES_HORAS_COUNT:
      return {
        ...state,
        informesHorasCount: action.payload,
      };

    // informes Horas
    case ActionTypes.SET_INFORMES_HORAS_INSTRUCTOR:
      return {
        ...state,
        informesHorasInstructor: action.payload,
      };
    case ActionTypes.SET_INFORMES_HORAS_INSTRUCTOR_COUNT:
      return {
        ...state,
        informesHorasInstructorCount: action.payload,
      };

    // informes infraestructura
    case ActionTypes.SET_INFORMES_INFRAESTRUCTURA:
      return {
        ...state,
        informesInfraestructura: action.payload,
      };
    case ActionTypes.SET_INFORMES_INFRAESTRUCTURA_COUNT:
      return {
        ...state,
        informesInfraestructuraCount: action.payload,
      };

    // filtros
    case ActionTypes.SET_SOCIEDADES_INFORMES:
      return {
        ...state,
        sociedades: action.payload,
      };
    case ActionTypes.SET_PROVINCIAS_INFORMES:
      return {
        ...state,
        provincias: action.payload,
      };
    case ActionTypes.SET_ALUMNOS_INFORMES:
      return {
        ...state,
        alumnos: action.payload,
      };
    case ActionTypes.SET_CURSOS_INFORMES:
      return {
        ...state,
        cursosFilter: action.payload,
      };
    case ActionTypes.SET_ESTADOS_INFORMES:
      return {
        ...state,
        estados: action.payload,
      };
    case ActionTypes.REMOVE_FILTERS_INFORMES:
      return {
        ...state,
        estados: [],
        cursosFilter: [],
        alumnos: [],
        provincias: [],
        sociedades: [],
      };
    // Cache
    case ActionTypes.SET_ALL_INFORMES_CURSOS_FILTER:
      return {
        ...state,
        allCursosFilter: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
